import client from '../client'

export const getSearchedVehiclesInfoKey = `${process.env.NEXT_PUBLIC_SEARCH_DOMAIN}/api/Search/GetSearchedVehiclesInformation`

export async function getSearchedVehiclesInfo(vehicleIds) {
  const params = new URLSearchParams()
  vehicleIds.map((id) => params.append('vehicleIds', id))

  return client(`${getSearchedVehiclesInfoKey}?${params}`)
}
